/**
 * 首屏执行：从 localStorage 读取主题偏好并立即应用，避免 FOUC。
 * 尽量小，不依赖任何模块。
 */
import { STORAGE_KEYS } from "@/config/constants";

type Theme = "light" | "dark" | "system";

try {
  const raw = localStorage.getItem(STORAGE_KEYS.PREFERENCES);
  const prefs = raw
    ? (JSON.parse(raw).state as { theme?: Theme; language?: string } | undefined)
    : undefined;

  const theme: Theme = prefs?.theme ?? "system";
  const language = prefs?.language ?? "zh-CN";

  const dark =
    theme === "dark" ||
    (theme === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches);

  const html = document.documentElement;
  html.classList.toggle("dark", dark);
  html.setAttribute("lang", language);
} catch {
  // ignore
}
